import { memo } from 'react';
import { CustomPagePresentation } from './components/CustomPagePresentation';
import { EventPresentation } from './components/EventPresentation';
import { FileFolderPresentation } from './components/FileFolderPresentation';
import { FilePresentation } from './components/FilePresentation';
import { FolderPresentation } from './components/FolderPresentation';
import { ForumPresentation } from './components/ForumPresentation';
import { GroupPresentation } from './components/GroupPresentation';
import { NewsPresentation } from './components/NewsPresentation';
import { OpportunityPresentation } from './components/OpportunityPresentation';
import { OrganizationPresentation } from './components/OrganizationPresentation';
import { PersonPresentation } from './components/PersonPresentation';
import { PostPresentation } from './components/PostPresentation';
import { ProjectPresentation } from './components/ProjectPresentation';
import { TrendingPresentation } from './components/TrendingPresentation';
import { CONTENT_TYPES } from './constants';
export const COMPONENT_BY_CONTENT_TYPE = {
    [CONTENT_TYPES.CUSTOM_PAGE]: memo(CustomPagePresentation),
    [CONTENT_TYPES.EVENT]: memo(EventPresentation),
    [CONTENT_TYPES.FILE]: memo(FilePresentation),
    [CONTENT_TYPES.FILEFOLDER]: memo(FileFolderPresentation),
    [CONTENT_TYPES.FOLDER]: memo(FolderPresentation),
    [CONTENT_TYPES.FORUM]: memo(ForumPresentation),
    [CONTENT_TYPES.GROUP]: memo(GroupPresentation),
    [CONTENT_TYPES.NEWS]: memo(NewsPresentation),
    [CONTENT_TYPES.OPPORTUNITY]: memo(OpportunityPresentation),
    [CONTENT_TYPES.ORGANIZATION]: memo(OrganizationPresentation),
    [CONTENT_TYPES.POST]: memo(PostPresentation),
    [CONTENT_TYPES.USER]: memo(PersonPresentation),
    [CONTENT_TYPES.PROJECT]: memo(ProjectPresentation),
    [CONTENT_TYPES.TRENDING]: memo(TrendingPresentation),
};
//# sourceMappingURL=componentByContentType.js.map